/* hej-functietabel-wegwijzer — zwevende app-iconen met een woord eronder rond de kies-je-kaarten (2026-10-12,
 * gebruikersverzoek, opvolger van de iconen die achter de kaart schuilden).
 *
 * Alleen in een functietabel met data-wegwijzer, en alleen vanaf 601px. Op de telefoon is naast de kaarten geen ruimte;
 * daar staat de rij met icoon en woord in de kaart zelf (.hej-ftab__gebruik, zie de css).
 *
 * Elke kaart heeft in die rij twee of drie iconen met een woord (snippets/hej-app-icoon.liquid). Dit script kopieert ze
 * naar zwevende figuurtjes (icoon plus woord) in de ruimte rond de kaarten: helemaal buiten de kaart, niet erachter, en
 * nooit over een andere kaart of de kop. Elke kaart heeft zijn eigen hoek waar zijn iconen in drie maten bij elkaar
 * zweven (gebruiker 2026-10-12). Ga je met de muis over een kaart, dan schuiven zijn iconen iets uit elkaar
 * (sinds 2026-10-13 zonder sprongetje). Dat laatste alleen met een echte muis (hover: hover en pointer: fine), dus niet op een iPad.
 *
 * De plekken worden gemeten, want het aantal kaarten, hun rijen en de breedte van het scherm verschillen. */
(function () {
  var breed = window.matchMedia('(min-width: 601px)');
  var muis = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* Vaste, herhaalbare "willekeur", zodat elke pagina er bij elke weergave hetzelfde uitziet. */
  function getal(n) { var x = Math.sin(n * 91.7 + 13.3) * 43758.5453; return x - Math.floor(x); }

  /* Per kaart een groot, een middel en een klein icoon (gebruiker: meer variatie), in een volgorde die per kaart wisselt.
     Sinds 2026-10-13 kleiner (gebruiker: "ik wil niet zulke grote iconen"). */
  var MATEN = [[64, 44, 32], [34, 60, 44], [46, 34, 62], [40, 56, 32]];

  /* Plekken rond een hoek: verschuivingen naar buiten vanaf het hoekpunt, horizontaal en verticaal. Negatief is langs
     de rand van de kaart naar binnen. Ze worden gesorteerd op afstand tot de hoek, zodat de iconen er dicht bij blijven. */
  var STAPPEN = [-96, -72, -48, -24, -4, 12, 30, 50];

  function figuur(li, sleutel, kaart, nr, j) {
    var item = li.querySelector('.hej-ftab__gebruik [data-sleutel="' + sleutel + '"]');
    if (!item) return null;
    var woord = item.parentNode.querySelector('.hej-ftab__gebruik-woord');
    var maat = 2 * Math.round((MATEN[kaart % MATEN.length][j % 3] + (getal(nr) - 0.5) * 8) / 2);
    var fig = document.createElement('span');
    fig.className = 'hej-ftab__zweef';
    fig.setAttribute('aria-hidden', 'true');
    fig.setAttribute('data-kaart', kaart);
    fig.style.setProperty('--hej-app-maat', maat + 'px');
    fig.style.setProperty('--hej-app-nr', nr);
    /* Het sprongetje zit op een binnenlaag, zodat het niet botst met het zweven van het figuurtje zelf. */
    var binnen = document.createElement('span');
    binnen.className = 'hej-ftab__zweef-binnen';
    var icoon = item.cloneNode(true);
    icoon.removeAttribute('data-sleutel');
    /* Eigen ids voor de verlopen in de kopie, anders verwijst hij naar die van het origineel in de kaart. */
    icoon.innerHTML = icoon.innerHTML.replace(/(hej-wit-|hej-app-boog-|hej-l1-|hej-l2-)[A-Za-z0-9_-]+/g, '$1z' + nr);
    binnen.appendChild(icoon);
    if (woord) {
      var w = document.createElement('span');
      w.className = 'hej-ftab__zweef-woord';
      w.textContent = woord.textContent;
      binnen.appendChild(w);
    }
    fig.appendChild(binnen);
    fig._maat = maat;
    fig._nr = nr;
    return fig;
  }

  function teken(sectie) {
    sectie.querySelectorAll('.hej-ftab__zweef').forEach(function (n) { n.remove(); });
    if (!breed.matches) return;
    var kop = sectie.querySelector('.hej-ftab__kop');
    var kaarten = Array.prototype.slice.call(sectie.querySelectorAll('.hej-ftab__kaartwrap'));
    if (!kop || !kaarten.length) return;

    var S = sectie.getBoundingClientRect();
    var B = S.width;
    var k = kop.getBoundingClientRect();
    var kopR = { l: k.left - S.left, r: k.right - S.left, t: k.top - S.top, b: k.bottom - S.top };
    var doelen = kaarten.map(function (li, i) {
      var r = li.getBoundingClientRect();
      return { i: i, li: li, l: r.left - S.left, r: r.right - S.left, t: r.top - S.top, b: r.bottom - S.top };
    });
    var H = S.height;
    var midden = B / 2;
    var geplaatst = [];
    var nr = 0;
    function raakt(a, b, marge) { return a.l < b.r + marge && a.r > b.l - marge && a.t < b.b + marge && a.b > b.t - marge; }
    function vrij(box, extra) {
      if (box.l < 8 || box.r > B - 8 || box.t < 8 || box.b > H - 8) return false;
      if (doelen.some(function (o) { return raakt(box, o, 10); })) return false;
      if (raakt(box, kopR, 12)) return false;
      return !geplaatst.concat(extra).some(function (g) { return raakt(box, g, 8); });
    }

    /* Proef "rustig" (2026-10-13, gebruiker, eerst op AMD Ryzen): per kaart een klein groepje dat aan de kaart vastzit,
       zonder woord. Een groot hoofdicoon (het eerste uit de lijst) ligt op de rechteronderhoek, voor een flink deel over
       de kaart; een kleiner tweede icoon zit er half achter, op de onderrand. Bij elke kaart rechtsonder, zodat de sectie
       een vast ritme heeft en geen groepje aan de lege linkerkant wegvalt (tweede ronde, 2026-10-13). Onder en niet
       boven, want rechtsboven staat de pijl. Bij hover schuiven de twee een stukje uit elkaar. */
    /* Drie proeven naast elkaar (2026-10-13, gebruiker): rustig (C, een groot en een klein icoon op de hoek) op AMD
       Ryzen, rand (A, twee even grote iconen die voor een kwart over de onderrand hangen) op Intel Core, en rij (B, geen
       zwevende iconen maar de rij met icoon en woord onderin de kaart, zie de css) op Apple M-chip. */
    var stijl = sectie.getAttribute('data-wegwijzer-stijl');
    /* Rij en portret (de staande glaskaarten) zetten de iconen in de kaart zelf; hier valt niets te tekenen. */
    if (stijl === 'rij' || stijl === 'portret') return;
    if (stijl === 'rustig' || stijl === 'rand') {
      /* [maat, midden x vanaf de hoek, midden y vanaf de hoek, hover x, hover y, laag] */
      var GROEP = stijl === 'rand'
        ? [[52, -14, -13, 5, 0, 3], [52, -76, -13, -5, 0, 2]]
        : [[64, -10, -10, 6, -3, 3], [40, -50, 8, -6, 2, 2]];
      doelen.forEach(function (t) {
        var sleutels = (t.li.getAttribute('data-iconen') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean).slice(0, 2);
        sleutels.forEach(function (s, j) {
          var g = GROEP[j];
          var fig = figuur(t.li, s, t.i, ++nr, j);
          if (!fig) return;
          var w = fig.querySelector('.hej-ftab__zweef-woord');
          if (w) w.remove();
          fig.style.setProperty('--hej-app-maat', g[0] + 'px');
          fig.style.left = Math.round(Math.min(t.r + g[1] - g[0] / 2, B - 8 - g[0])) + 'px';
          fig.style.top = Math.round(t.b + g[2] - g[0] / 2) + 'px';
          fig.style.setProperty('--hej-uit-x', g[3] + 'px');
          fig.style.setProperty('--hej-uit-y', g[4] + 'px');
          fig.style.zIndex = g[5];
          sectie.appendChild(fig);
        });
      });
      return;
    }

    doelen.forEach(function (t) {
      var sleutels = (t.li.getAttribute('data-iconen') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      if (!sleutels.length) return;
      var figs = [];
      sleutels.forEach(function (s, j) { var f = figuur(t.li, s, t.i, ++nr, j); if (f) figs.push(f); });
      if (!figs.length) return;
      /* De echte maat van icoon plus woord meten: een woord als "Laagste prijs" is breder dan een klein icoon en liep
         anders over de kaart (2026-10-13). Onzichtbaar neerzetten, meten, daarna op de goede plek zetten. */
      figs.forEach(function (fig) {
        fig.style.visibility = 'hidden';
        fig.style.left = '0px';
        fig.style.top = '0px';
        sectie.appendChild(fig);
        fig._b = fig.offsetWidth;
        fig._h = fig.offsetHeight;
      });
      /* Groot eerst: die krijgt de plek het dichtst bij de hoek, de kleinere eromheen. */
      var opMaat = figs.slice().sort(function (a, b) { return b._maat - a._maat; });

      /* Elke kaart zijn eigen hoek: liefst aan de buitenkant, om en om boven en onder, zodat kaarten naast elkaar niet
         allemaal dezelfde hoek pakken. Past het daar niet, dan de volgende hoek. */
      var dxBuiten = (t.l + t.r) / 2 < midden ? -1 : 1;
      var dyEerst = t.i % 2 === 0 ? -1 : 1;
      var hoeken = [[dxBuiten, dyEerst], [dxBuiten, -dyEerst], [-dxBuiten, dyEerst], [-dxBuiten, -dyEerst]];
      /* De losse gecentreerde laatste kaart (oneven aantal) altijd eerst rechtsonder (gebruiker 2026-10-13). */
      if (doelen.length > 1 && t.i === doelen.length - 1 && doelen.length % 2 === 1) hoeken = [[1, 1], [-1, 1], [1, -1], [-1, -1]];
      var gelukt = false;

      for (var h = 0; h < hoeken.length && !gelukt; h++) {
        var dx = hoeken[h][0], dy = hoeken[h][1];
        var hx = dx > 0 ? t.r : t.l, hy = dy > 0 ? t.b : t.t;
        var boxen = [];
        gelukt = opMaat.every(function (fig) {
          var m = fig._b, hoog = fig._h;
          var opties = [];
          STAPPEN.forEach(function (u) {
            STAPPEN.forEach(function (v) {
              var l = dx > 0 ? hx + u : hx - u - m;
              var top = dy > 0 ? hy + v : hy - v - hoog;
              var mx = l + m / 2 - hx, my = top + hoog / 2 - hy;
              opties.push({ box: { l: l, r: l + m, t: top, b: top + hoog }, af: Math.sqrt(mx * mx + my * my) + getal(fig._nr + u + v) * 18 });
            });
          });
          opties.sort(function (a, b) { return a.af - b.af; });
          for (var o = 0; o < opties.length; o++) {
            if (vrij(opties[o].box, boxen)) { boxen.push(opties[o].box); fig._box = opties[o].box; return true; }
          }
          return false;
        });
      }
      if (!gelukt) { figs.forEach(function (fig) { fig.remove(); }); return; }
      /* Bij hover schuiven de iconen een stukje uit elkaar, weg van het midden van hun groepje (gebruiker 2026-10-13). */
      var mx = 0, my = 0;
      figs.forEach(function (fig) { mx += (fig._box.l + fig._box.r) / 2; my += (fig._box.t + fig._box.b) / 2; });
      mx /= figs.length; my /= figs.length;
      figs.forEach(function (fig, j) {
        geplaatst.push(fig._box);
        fig.style.left = Math.round(fig._box.l) + 'px';
        fig.style.top = Math.round(fig._box.t) + 'px';
        fig.style.visibility = '';
        var vx = (fig._box.l + fig._box.r) / 2 - mx, vy = (fig._box.t + fig._box.b) / 2 - my;
        var len = Math.sqrt(vx * vx + vy * vy);
        fig.style.setProperty('--hej-uit-x', (len ? Math.round(vx / len * 16) : 0) + 'px');
        fig.style.setProperty('--hej-uit-y', (len ? Math.round(vy / len * 16) : 0) + 'px');
        fig.style.setProperty('--hej-sprong-nr', j);
      });
    });
  }

  function koppel(sectie) {
    sectie.querySelectorAll('.hej-ftab__kaartwrap').forEach(function (li, i) {
      function figuurtjes() { return sectie.querySelectorAll('.hej-ftab__zweef[data-kaart="' + i + '"]'); }
      li.addEventListener('mouseenter', function () {
        if (!muis.matches) return;
        /* Alleen uit elkaar, geen sprongetje meer (gebruiker 2026-10-13: "niet stuiteren"). */
        figuurtjes().forEach(function (f) { f.classList.add('is-uit'); });
      });
      li.addEventListener('mouseleave', function () { figuurtjes().forEach(function (f) { f.classList.remove('is-uit'); }); });
    });
  }

  function start() {
    document.querySelectorAll('.hej-ftab[data-wegwijzer]').forEach(function (sectie) {
      if (sectie.hasAttribute('data-wegwijzer-klaar')) return;
      sectie.setAttribute('data-wegwijzer-klaar', '');
      koppel(sectie);
      var wacht = 0;
      var opnieuw = function () { cancelAnimationFrame(wacht); wacht = requestAnimationFrame(function () { teken(sectie); }); };
      opnieuw();
      window.addEventListener('resize', opnieuw);
      if ('ResizeObserver' in window) new ResizeObserver(opnieuw).observe(sectie.querySelector('.hej-ftab__inner') || sectie);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(opnieuw);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
